import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/* Fonts:
   - Fraunces `full`: every axis (WONK and SOFT) for display headlines.
   - Instrument Serif Italic: pull quotes, editorial accents, curator side-notes.
   - Space Mono 400 Latin: reserved strictly for narrow technical spots (receipts, tracking).
   - General Sans: loaded via Fontshare for UI chrome, navigation, prices, and body. */
import '@fontsource-variable/fraunces/full.css';
import '@fontsource/instrument-serif/latin-400-italic.css';
import '@fontsource-variable/instrument-sans/wght.css';
import '@fontsource/space-mono/latin-400.css';

import './styles/index.css';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
